const initialState = {
  currentPage : 0,
  pagesCount : 0,
  pageSize : 20,
  orderBy : null,
  invoices : [],
  isLoading: true
}

const reducer = (state = initialState, action) => {
  if (action.type === 'INVOICES_LOAD_STARTED') {
    return {
      ...state,
      isLoading: true
    }
  }
  if (action.type === 'INVOICES_LOAD_ERROR') {
    return {
      ...state,
      isLoading: false
    }
  }
  if (action.type === 'INVOICES_PAGE_LOADED') {
    return {
      ...state,
      pagesCount: action.pagesCount,
      currentPage: action.currentPage,
      invoices: action.invoices,
      isLoading: false
    }
  }
  if (action.type === 'INVOICES_SORTING_CHANGED') {
    return {
      ...state,
      orderBy: action.value
    }
  }
  if (action.type === 'INVOICES_PAGE_SIZE_CHANGED') {
    return {
      ...state,
      pageSize: action.value
    }
  }

  return state;
}

export default reducer;